import { type Meta } from '@storybook/react';
import { PropsWithChildren } from 'react';

/** @see src/css/legacy.scss */
const LEGACY_CLASS_NAME = 'LEGACY';

type Props = PropsWithChildren;

export function WithLegacy(props: Props) {
  return <div className={LEGACY_CLASS_NAME}>{props.children}</div>;
}

type StoryDecorator = NonNullable<Meta['decorators']>[number];

export const withLegacyStoryDecorator: StoryDecorator = (Story) => (
  <WithLegacy>
    <Story />
  </WithLegacy>
);
